import { render, staticRenderFns } from "./ModuleStatusBadge.vue?vue&type=template&id=6370e94f&scoped=true&"
import script from "./ModuleStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ModuleStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./ModuleStatusBadge.vue?vue&type=style&index=0&id=6370e94f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6370e94f",
  null
  
)

export default component.exports